// Generated by scripts/update-seeq-icons.js from src/svg/seeq/all-items.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcAllItems = {
  prefix: 'fak',
  iconName: 'all-items' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e912',
    'M184.3 215c0 50.9-41.3 92.2-92.1 92.2s-92.2-41.3-92.2-92.2c0-50.9 41.3-92.2 92.2-92.1s92.2 41.3 92.1 92.1zM942.1 271.4h-599.1c-46.1 0-81.9-35.8-81.9-82s35.8-81.9 81.9-81.9h599.1c46.1 0 81.9 35.8 81.9 81.9s-35.8 81.9-81.9 82zM184.3 506.9c0 50.9-41.3 92.2-92.1 92.1s-92.2-41.3-92.2-92.1c0-50.9 41.3-92.2 92.2-92.2s92.2 41.3 92.1 92.2zM942.1 588.8h-599.1c-46.1 0-81.9-35.8-81.9-81.9s35.8-81.9 81.9-81.9h599.1c46.1 0 81.9 35.8 81.9 81.9s-35.8 81.9-81.9 81.9zM184.3 824.3c0 50.9-41.3 92.2-92.1 92.2s-92.2-41.3-92.2-92.2c0-50.9 41.3-92.2 92.2-92.1s92.2 41.3 92.1 92.1zM942.1 906.2h-599.1c-46.1 0-81.9-35.8-81.9-81.9s35.8-81.9 81.9-81.9h599.1c46.1 0 81.9 35.8 81.9 81.9s-35.8 81.9-81.9 81.9z',
  ],
} satisfies IconDefinition;
